export default "__VITE_ASSET__Cic8S1VP__"